<template>
    <v-simple-table>
        <thead>
            <tr>
                <th class="text-center" />
                <th v-for="header in config.headers" :key="header" class="text-center">
                    {{ header }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="row in config.rows" :key="row.key">
                <td>{{ row.label }}</td>
                <td v-for="field in row.fields" :key="field.key">
                    <component
                        :is="getFieldComponent(field)"
                        v-bind="getFieldProps(field)"
                        v-model="form[field.model]"
                        :disabled="disabled"
                    />
                </td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import { VTextField, VSelect } from 'vuetify/lib'

export default {
    name: 'FixationsTable',
    components: {
        VTextField,
        VSelect
    },
    props: {
        config: { type: Object, required: true },
        form: { type: Object, required: true },
        disabled: { type: Boolean, default: false },
        dropdowns: { type: Object, default: () => ({}) }
    },

    methods: {
        getFieldComponent(field) {
            return field.type === 'select' ? 'v-select' : 'v-text-field'
        },

        getFieldProps(field) {

            const baseProps = { ...field.props }

            switch (field.type) {
                case 'select':
                    baseProps.items = this.dropdowns[field.dropdown] || [];
                    baseProps.itemText = 'label';
                    baseProps.itemValue = 'value';
                    break;
                case 'number':
                    baseProps.type = 'number';
                    break;
            }

            return baseProps
        }
    }
}
</script>